// P6 · Optional thematic-context panel. Collapsible, collapsed by default — forcing
// systemic context on episodic-preferring readers backfires (Spinde), so it's opt-in.

import { INK } from "../style";

export function ContextPanel({ open, block, onToggle }: { open: boolean; block: string; onToggle: () => void }) {
  return (
    <section style={{ marginTop: 16, background: "#fff", border: "1px solid rgba(55,53,47,.12)", borderRadius: 6 }}>
      <button onClick={onToggle} style={{ width: "100%", display: "flex", alignItems: "center", gap: 11, padding: "15px 22px", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", textAlign: "left" }}>
        <span style={{ display: "inline-block", fontSize: 11, color: "rgba(55,53,47,.4)", transform: open ? "rotate(90deg)" : "none", transition: "transform .15s" }}>▸</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: INK }}>Broader context on this kind of incident</div>
          <div style={{ fontSize: 11.5, color: "rgba(55,53,47,.5)" }}>Optional: systemic background, collapsed by default.</div>
        </div>
      </button>
      {open && (
        <div className="lensfade" style={{ padding: "2px 22px 20px 50px" }}>
          <p style={{ margin: 0, fontSize: 14.5, lineHeight: 1.7, color: "rgba(55,53,47,.72)" }}>{block}</p>
        </div>
      )}
    </section>
  );
}
